import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainContainer = styled.div`
  display: flex;

  z-index: 5;
  background: white;
  position: fixed;
  width: 94%;
  top: 0;
  align-items: center;
  padding: 0 3%;
  height: 64px;
  justify-content: space-between;
  box-shadow: 0 0 5px 0 #aaaaaa;
`;

export const BrandLogo = styled.img`
  width: 32%;

  @media (max-width: 800px) {
    width: 25%;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  width: 16%;
  justify-content: space-between;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const ScrollyNavLink = styled.a`
  text-decoration: none;
  color: black;
  font-size: 12px;
  font-family: "Noto Sans", sans-serif;
`;

export const NavLink = styled(Link)`
  text-decoration: none;
  color: black;
  font-size: 12px;
  font-family: "Noto Sans", sans-serif;
`;
